import type { FC, PropsWithChildren } from "react";

export const LimitHeaderSubtitle: FC<PropsWithChildren> = props => {
	const {
		children
	} = props;

	return (
		<p className="type-description">
			{children}
		</p>
	);
};
